export const dialogText = `Collecting sizes for apparel items just got easier! You can create a unique link
      which will direct your recipients to a landing page where they can enter their
      sizes. You will then be able to see the selections that have been made in your
      Swag.com account so you can easily place an order for exactly what you need!`;